import http from '@/utils/http.js'

/*
 * @DESC:api接口
 */
const 	GET_MASS = "/api/getMass", //获取发送的消息
		SEND_MASS = "/api/sendMass", //发送群发消息
		DEL_MASS = "/api/deleteMass" //删除群发消息
export default {
	getMass: async({
		commit,
	}, params={}) => {
		try{
			const data = await http.get(GET_MASS,params)
			commit('GET_MASS', data)
		}catch(e){
			throw e
		}
	},
	sendMass: ({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		return http.post(SEND_MASS,params)
	},
	
	deleteMass: ({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		return new Promise((resolve, reject) => {
			http.post(DEL_MASS,params)
				.then((data = {}) => {
					resolve();
				},(err)=>{
					reject(err.message)
				})
		})
	}
}


// WEBPACK FOOTER //
// ./src/store/mp/wechat/mass/actions.js